import subscriberScope from './subscriber';

export default subscriberScope;
